import PAImage from "component/design-system/images/PAImage";
import PAText from "component/design-system/typography/PAText/PAText";
import PriceRange from "modules/components/prices/range-price/PriceRange";
import RatingUI from "modules/third-party/sitejabber/RatingUI";
import Link from "next/link";
import PropTypes from "prop-types";
import HideIf from "util/HideIf";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { isValidLink } from "util/isValidLinkDetail";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import SliderCard from "./SliderCard";
import styles from "./manufacturer.module.scss";

export const ProductCard = (props: any) => {
  const {
    url, linkDetails, pageDetails, showManufacturerImage = false,
  } = props;
  const { href, asPath } = getHrefAndPath({ asPath: url });
  const {
    image, minimumPrice, maximumPrice, description,
  } = linkDetails || {};
  const { pageDisplayableTitle, productLineId, manufacturerImageUrl } = pageDetails || {};
  const productImageSrc = (image && `/cms/${image}`) || "/images/common/image-not-available_16051144.png";

  return (
    (
      <Link
        href={href}
        as={asPath}
        title={`Dive into Quality: Explore ${pageDisplayableTitle}`}
        className={styles.product_item_link}
      >

        <div className={styles.product_item}>
          <div className={styles.product_item_image_container}>
            <PAImage
              width={166}
              height={166}
              src={getRelativeImagePath(productImageSrc)}
              alt={`Find the best auto part for your vehicle: ${description}`}
              title={`Find the best auto part for your vehicle: ${description}`}
              className={styles.product_item_image}
            />
          </div>

          <div className={styles.product_item_description}>
            <HideIf show={showManufacturerImage}>
              <PAImage
                width={70}
                height={30}
                src={manufacturerImageUrl || "/images/common/image-not-available_16051144.png"}
                alt={`Find the best auto part for your vehicle: ${description}`}
                title={`Find the best auto part for your vehicle: ${description}`}
              />
            </HideIf>

            <PAText
              inlineBlock
              className={styles.product_item_title}
              color="black"
              bold
              title={pageDisplayableTitle}
            >
              {pageDisplayableTitle}

            </PAText>

            <RatingUI
              {...{
                PRODUCT_ID: productLineId,
              }}
            />

            <PriceRange minimumPrice={minimumPrice} maximumPrice={maximumPrice} className={styles.product_price_range} />
          </div>
        </div>

      </Link>
    )
  );
};

const Products = (props: any) => {
  const { productLines } = props;

  const updatedProductLines = productLines.filter((productLine) => isValidLink(productLine.linkDetails));

  return (
    <SliderCard {...{
      categoryUrls: updatedProductLines,
      title: "Products",
    }}
    >
      <ProductCard />
    </SliderCard>
  );
};

Products.propTypes = {
  productLines: PropTypes.array.isRequired,
};

export default Products;
